<div class="ws-popup-header">
    <span>{{'Language' | translate}}</span>
    <div class="actions">
        <button (click)="onCancelClick()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<div class="ws-popup-content">
    <div class="input-wrapper">
        <label>{{'Language' | translate}}</label>
        <mat-select [(value)]="selectedLanguage">
            <mat-option value="it">{{'Italian' | translate}}</mat-option>
            <mat-option value="en">{{'English' | translate}}</mat-option>
            <mat-option value="de">{{'German' | translate}}</mat-option>
        </mat-select>
    </div>
</div>

<div class="ws-popup-footer">
    <span></span>
    <div class="actions-footer">
        <ws-button (click)="onCancelClick()" [callToActionType]="'tertiary'">
            {{'Cancel' | translate}}
        </ws-button>
        <ws-button (click)="onConfirmClick()" [callToActionType]="'primary'">
            {{'Print gift' | translate}}
        </ws-button>
    </div>
</div>